import Api from 'services/Api';
import Validator from 'services/Validator';
import store from 'store/index';
import { previousValid } from 'store/generators/step';

export const mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    UPDATE_INCLUDE: 'UPDATE_INCLUDE',
    RESET: 'RESET',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
};

const cruTemplate = () => ({
    value: 0,
    include: false,
});


// Initial State
const state = {
    gdPneumoconiosis: cruTemplate(),
    gdMesothelioma: cruTemplate(),
    ploeDisabilityWorkingAllowance: cruTemplate(),
    ploeEmploymentSupportAllowance: cruTemplate(),
    ploeIncapacityBenefit: cruTemplate(),
    ploeIncomeSupport: cruTemplate(),
    ploeIndustrialInjuriesDisablementBenefit: cruTemplate(),
    ploeInvalidityPension: cruTemplate(),
    ploeInvalidityAllowance: cruTemplate(),
    ploeJobseekersAllowance: cruTemplate(),
    ploeReducedEarningsAllowance: cruTemplate(),
    ploeSevereDisablementAllowance: cruTemplate(),
    ploeSicknessBenefit: cruTemplate(),
    ploeStatutorySickPay: cruTemplate(),
    ploeUnemployabilitySupplement: cruTemplate(),
    ploeUnemploymentBenefit: cruTemplate(),
    ploeUniversalCredit: cruTemplate(),
    pcocAttendanceAllowance: cruTemplate(),
    pcocDisabilityLivingAllowance: cruTemplate(),
    pcocIndustrialInjuriesDisablementBenefit: cruTemplate(),
    pcocPersonalIndependencePayment: cruTemplate(),
    pcotDisabilityLivingAllowance: cruTemplate(),
    pcotMobilityAllowance: cruTemplate(),
    pcotPersonalIndependencePayment: cruTemplate(),
};

/**
 * Validation Rules.
 * 
 * @type {Object}
 */
const rules = {
    
};

const returnCruValue = (cru) => {
    if (cru.include) {
        return parseFloat(cru.value)
    }
    return 0;
};

const generalDamagesOffset = (state) =>  {
    let cruTotal = returnCruValue(state.gdPneumoconiosis) + returnCruValue(state.gdMesothelioma);
    let gdHeadOfLoss = store.getters['fatal/estate/headsOfLoss/value']('generalDamages');

    if (cruTotal >= gdHeadOfLoss) {
        return gdHeadOfLoss;
    }

    return cruTotal;
};

const pastLossOfEarningsOffset = (state) =>  {
    let cruTotal = returnCruValue(state.ploeDisabilityWorkingAllowance) +
        returnCruValue(state.ploeEmploymentSupportAllowance) +
        returnCruValue(state.ploeIncapacityBenefit) +
        returnCruValue(state.ploeIncomeSupport) +
        returnCruValue(state.ploeIndustrialInjuriesDisablementBenefit) +
        returnCruValue(state.ploeInvalidityPension) +
        returnCruValue(state.ploeInvalidityAllowance) +
        returnCruValue(state.ploeJobseekersAllowance) +
        returnCruValue(state.ploeReducedEarningsAllowance) +
        returnCruValue(state.ploeSevereDisablementAllowance) +
        returnCruValue(state.ploeSicknessBenefit) +
        returnCruValue(state.ploeStatutorySickPay) +
        returnCruValue(state.ploeUnemployabilitySupplement) +
        returnCruValue(state.ploeUnemploymentBenefit) +
        returnCruValue(state.ploeUniversalCredit);

    let ploeHeadOfLoss = store.getters['fatal/estate/headsOfLoss/value']('pastLossOfEarnings');

    if (cruTotal >= ploeHeadOfLoss) {
        return ploeHeadOfLoss;
    }

    return cruTotal;
};

const pastCostOfCareOffset = (state) =>  {
    let cruTotal = returnCruValue(state.pcocAttendanceAllowance) +
        returnCruValue(state.pcocDisabilityLivingAllowance) +
        returnCruValue(state.pcocIndustrialInjuriesDisablementBenefit) +
        returnCruValue(state.pcocPersonalIndependencePayment);

    let pcocHeadOfLoss = store.getters['fatal/estate/headsOfLoss/value']('pastCostOfCare');

    if (cruTotal >= pcocHeadOfLoss) {
        return pcocHeadOfLoss;
    }

    return cruTotal;
};

const pastCostOfTravelOffset = (state) =>  {
    let cruTotal = returnCruValue(state.pcotDisabilityLivingAllowance) +
        returnCruValue(state.pcotMobilityAllowance) +
        returnCruValue(state.pcotPersonalIndependencePayment);

    let pcotHeadOfLoss = store.getters['fatal/estate/headsOfLoss/value']('pastCostOfTravel');

    if (cruTotal >= pcotHeadOfLoss) {
        return pcotHeadOfLoss;
    }

    return cruTotal;
};

// Getters
const getters = {
    value: state => key => state[key].value,
    include: state => key => state[key].include,
    allValid: state => Object.keys(state).reduce((valid, benefit) => !valid ? valid : !(state[benefit].include == true && state[benefit].value <= 0), true),
    all: state => state,
    gdPneumoconiosis: state => state.gdPneumoconiosis,
    gdMesothelioma: state => state.gdMesothelioma,
    ploeDisabilityWorkingAllowance: state => state.ploeDisabilityWorkingAllowance,
    ploeEmploymentSupportAllowance: state => state.ploeEmploymentSupportAllowance,
    ploeIncapacityBenefit: state => state.ploeIncapacityBenefit,
    ploeIncomeSupport: state => state.ploeIncomeSupport,
    ploeIndustrialInjuriesDisablementBenefit: state => state.ploeIndustrialInjuriesDisablementBenefit,
    ploeInvalidityPension: state => state.ploeInvalidityPension,
    ploeInvalidityAllowance: state => state.ploeInvalidityAllowance,
    ploeJobseekersAllowance: state => state.ploeJobseekersAllowance,
    ploeReducedEarningsAllowance: state => state.ploeReducedEarningsAllowance,
    ploeSevereDisablementAllowance: state => state.ploeSevereDisablementAllowance,
    ploeSicknessBenefit: state => state.ploeSicknessBenefit,
    ploeStatutorySickPay: state => state.ploeStatutorySickPay,
    ploeUnemployabilitySupplement: state => state.ploeUnemployabilitySupplement,
    ploeUnemploymentBenefit: state => state.ploeUnemploymentBenefit,
    ploeUniversalCredit: state => state.ploeUniversalCredit,
    pcocAttendanceAllowance: state => state.pcocAttendanceAllowance,
    pcocDisabilityLivingAllowance: state => state.pcocDisabilityLivingAllowance,
    pcocIndustrialInjuriesDisablementBenefit: state => state.pcocIndustrialInjuriesDisablementBenefit,
    pcocPersonalIndependencePayment: state => state.pcocPersonalIndependencePayment,
    pcotDisabilityLivingAllowance: state => state.pcotDisabilityLivingAllowance,
    pcotMobilityAllowance: state => state.pcotMobilityAllowance,
    pcotPersonalIndependencePayment: state => state.pcotPersonalIndependencePayment,
    getGeneralDamagesOffset: state => generalDamagesOffset(state),
    getPastLossOfEarningsOffset: state => pastLossOfEarningsOffset(state),
    getPastCostOfCareOffset: state => pastCostOfCareOffset(state),
    getPastCostOfTravelOffset: state => pastCostOfTravelOffset(state)
};

// Actions
const actions = {
    /**
     * Update cru value
     *
     * @param commit
     * @param state
     * @param dispatch
     * @param key
     * @param value
     */
    updateValue({ commit, state, dispatch }, { key, value }) {
        if (state[key].value !== value) {
            return commit(mutationTypes.UPDATE_VALUE, { key, value });
        }
        return value;
    },

    /**
     * Update cru include
     *
     * @param commit
     * @param state
     * @param key
     * @param value
     */
    updateInclude({ commit, state }, { key, value }) {
        if (state[key].include !== value) {
            return commit(mutationTypes.UPDATE_INCLUDE, { key, value });
        }
        return value;
    },

    /**
     * Update the step from server load
     *
     * @param commit
     * @param data
     */
    updateFromServer({ commit }, { data }) {
        Object.keys(data).forEach((key) => {
            commit(mutationTypes.UPDATE_FROM_SERVER, { key: key, value: _.values(data[key]) });
        });
        return true;
    },

    /**
     * Save the step by submitting to the server.
     *
     * @param state
     * @param dispatch
     * @param payload
     */
    save({ state, dispatch }, payload) {
        // We might change this to something which
        // is a bit cleaner...
        payload.data = state;

        Api.claims.save(payload).then((response) => {
            return response;
        });
    },

    /**
     * Loads the step being received from the Server, to be placed in the state.
     *
     * @param commit
     * @param step
     */
    load({ dispatch }, step) {
        const data = _.deeply(_.mapKeys)(step, (value, key) => _.camelCase(key)).data;

        dispatch('updateFromServer', {data});
    },

    /**
     * Validate the step.
     *
     * @param commit
     */
    validate({rootState}) {
        store.dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 3,
            valid: previousValid(rootState, 3) && (new Validator(state, rules)).validate(), 
        });
    },

    /**
     * Performs any processing once the data from the server has been stored.
     * This is a good place to do calculations or dispatch other actions which
     * are used to refresh/update calculated data on other steps/components.
     *
     * @param dispatch
     */
    process({rootState}) {
        store.dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 3,
            valid: previousValid(rootState, 3) && (new Validator(state, rules)).validate(),
        });
    },

    /**
     * Resets the step back to defaults
     *
     * @param commit
     */
    reset({ commit }) {
        store.dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 3,
            valid: false,
        });

        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_FROM_SERVER](state, { key, value }) {
        state[key].value = value[0];
        state[key].include = value[1];
    },
    [mutationTypes.UPDATE_VALUE](state, { key, value }) {
        state[key].value = value;
    },
    [mutationTypes.UPDATE_INCLUDE](state, { key, value }) {
        state[key].include = value;
    },
    [mutationTypes.RESET](state) {
        Object.keys(state).forEach((key) => {
            state[key] = cruTemplate();
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/fatal/estate/cru.js